import { Box, Flex, FlexProps } from '@chakra-ui/react';

import { formatTimeValue } from '~/hooks/use-countdown';

export type CountdownTimerProps = {
  containerProps?: FlexProps;
  days: number;
  hours: number;
  hoursOnly?: boolean;
  minutes: number;
  seconds: number;
};

export function CountdownTimer({ days, hours, minutes, seconds, containerProps, hoursOnly }: CountdownTimerProps) {
  return (
    <Flex alignItems='center' {...containerProps}>
      {!hoursOnly && <TimeBox label='day' value={formatTimeValue(days)} />}
      <TimeBox label='hrs' value={formatTimeValue(hours)} />
      <TimeBox label='min' value={formatTimeValue(minutes)} />
      <TimeBox label='sec' value={formatTimeValue(seconds)} />
    </Flex>
  );
}
function TimeBox({ value, label }: { value: string; label: string }) {
  return (
    <Flex
      alignItems='center'
      flex='0 1 46px'
      flexDir='column'
      minWidth='32px'
      position='relative'
      textAlign='center'
      _notLast={{
        '&::after': {
          content: "':'",
          display: 'block',
          position: 'absolute',
          top: 0,
          transform: 'translate(50%, 0%)',
          right: 0,
          opacity: '0.75',
          fontSize: {
            base: 'xs',
            md: 'lg',
            xl: 'xl',
          },
        },
      }}
    >
      <Box
        fontFamily='body'
        fontWeight='600'
        fontSize={{
          base: 'lg',
          xl: 'xl',
        }}
        sx={{
          fontFeatureSettings: 'tnum',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {value}
      </Box>
      <Box
        color='supportBlue.40'
        fontFamily='heading'
        fontSize='2xs'
        fontWeight='600'
        letterSpacing={1.1}
        textTransform='uppercase'
      >
        {label}
      </Box>
    </Flex>
  );
}
